module.exports = __webpack_public_path__ + "static/appStore-ea3693a540100c149ed10a73fe15dd1b.svg";